{
  "nav": {
    "usuaris": "Usuaris",
    "rols": "Rols i permisos",
    "usuarisInformar": "Usuaris a informar",
    "arees": "Estructura",
    "documentacio": "Documentació",
    "circuits": "Circuits d'escalat",
    "canals": "Canals",
    "plantilles": "Plantilles",
    "zones": "Zones",
    "integracions": "Integracions",
    "versions": "Versions de l'app",
    "configuracio": "Configuració",
    "detallUsuari": "Detall d'usuari",
    "importacio": "Importació des d'Excel",
    "politicaFitxers": "Política de fitxers",
    "detallDocument": "Detall del document"
  },
  "titols": {
    "usuaris": "Usuaris",
    "rols": "Rols i matriu de permisos",
    "usuarisInformar": "Usuaris a informar",
    "arees": "Estructura",
    "documentacio": "Biblioteca de documentació",
    "circuits": "Circuits d'escalat",
    "canals": "Canals i polítiques de notificació",
    "plantilles": "Plantilles de missatge",
    "zones": "Zones i ubicacions",
    "integracions": "Integracions",
    "versions": "Versions de l'app i missatges administratius",
    "configuracio": "Configuració general i retenció",
    "detallUsuari": "Detall d'usuari",
    "importacio": "Importació d'usuaris a informar des d'Excel",
    "politicaFitxers": "Política de fitxers",
    "detallDocument": "Detall del document"
  },
  "comu": {
    "carregant": "Carregant…",
    "desa": "Desa",
    "desat": "Canvis desats correctament.",
    "cancella": "Cancel·la",
    "edita": "Edita",
    "elimina": "Elimina",
    "actiu": "Actiu",
    "inactiu": "Inactiu",
    "tria": "Tria una opció",
    "torna": "Torna",
    "anterior": "Anterior",
    "seguent": "Següent",
    "enrere": "Enrere",
    "pagina": "Pàgina {{actual}} de {{total}}",
    "recarrega": "Torna a carregar",
    "fa": {
      "ara": "ara mateix",
      "min": "fa {{count}} min",
      "h": "fa {{count}} h",
      "dies": "fa {{count}} dies"
    }
  },
  "altaPersona": {
    "boto": "Nova persona",
    "titol": "Donar d'alta una persona",
    "etiqueta": "Persones",
    "ajuda": "Cerca la persona al directori corporatiu (Entra ID) i tria quin rol tindrà i on.",
    "cerca": "Persona",
    "cercaPlaceholder": "Escriu nom, cognoms o correu (mínim 2 lletres)",
    "cercant": "Cercant…",
    "senseResultats": "No s'ha trobat cap persona al directori.",
    "jaAlCai": "Ja és al CAI",
    "canvia": "Canvia",
    "rol": "Rol",
    "rolPlaceholder": "Tria un rol",
    "on": "On s'aplica",
    "global": "Tota l'organització",
    "triaAmbit": "Cerca departament, àrea o servei",
    "ambitTriat": "Àmbit",
    "crea": "Dona d'alta",
    "cancella": "Cancel·la"
  },
  "usuaris": {
    "sincronitza": "Sincronitza amb Entra ID",
    "sincronitzant": "Sincronitzant…",
    "resultatSync": "Sincronització completada: {{creats}} creats, {{actualitzats}} actualitzats, {{desactivats}} desactivats.",
    "cerca": "Cerca per nom, correu o UPN",
    "rol": "Rol",
    "totsRols": "Tots els rols",
    "departament": "Departament",
    "totsDepartaments": "Tots els departaments",
    "estat": "Estat",
    "totsEstats": "Tots els estats",
    "total": "{{count}} usuaris",
    "buit": "No hi ha usuaris que coincideixin amb els filtres.",
    "persona": "Persona",
    "carrec": "Càrrec",
    "idioma": "Idioma",
    "ultimSync": "Última sincronització",
    "totsN": "Tots ({{count}})",
    "correu": "Correu corporatiu",
    "sincronitzacio": "Sincronització",
    "sincronitzat": "Sincronitzat",
    "pendent": "Pendent"
  },
  "detallUsuari": {
    "titol": "Detall d'usuari",
    "afegeixRol": "Afegeix rol",
    "rol": "Rol",
    "ambit": "Àmbit",
    "ambitId": "Element de l'àmbit",
    "treuRol": "Treu el rol {{rol}}",
    "upn": "UPN",
    "email": "Correu electrònic",
    "telefon": "Telèfon",
    "idioma": "Idioma preferit",
    "ultimSync": "Última sincronització",
    "origenEntra": "Dades corporatives sincronitzades des de Microsoft Entra ID",
    "canals": "Canals verificats",
    "senseCanals": "No té canals verificats.",
    "verificat": "Verificat",
    "noVerificat": "No verificat",
    "dispositius": "Dispositius",
    "senseDispositius": "No té cap dispositiu registrat.",
    "critiquesActives": "Alertes crítiques actives",
    "critiquesInactives": "Alertes crítiques desactivades",
    "rolsGlobals": "Rols globals",
    "rolsAmbit": "Rols per àrea o servei",
    "senseRols": "Sense rols assignats.",
    "activitat": "Activitat recent",
    "abast": "Abast",
    "areaServei": "Àrea / servei",
    "assignat": "Assignat",
    "dadesEntra": "Dades corporatives (Entra ID)",
    "alDia": "Al dia",
    "senseActivitat": "Sense activitat registrada",
    "resultatKo": "amb error"
  },
  "rols": {
    "nou": "Nou rol",
    "codi": "Codi",
    "nomCa": "Nom (català)",
    "nomEs": "Nom (castellà)",
    "descripcio": "Descripció",
    "sistema": "Rol del sistema",
    "cercaRecurs": "Filtra recursos",
    "desaPermisos": "Desa els permisos",
    "ajuda": "Els permisos són dinàmics: marca els accessos que té aquest rol sobre cada recurs. L'assignació del rol a cada persona pot ser global o per àrea/servei.",
    "desats": "Permisos del rol desats.",
    "recurs": "Recurs",
    "acces": {
      "CONSULTAR": "Consultar",
      "ALTA": "Alta",
      "MODIFICAR": "Modificar",
      "ELIMINAR": "Eliminar"
    },
    "permisDe": "Permís {{acces}} sobre {{recurs}}",
    "llista": "Rols",
    "permis": "Permís",
    "abast": "Accés",
    "actiu": "Actiu",
    "actius": "{{count}} permisos actius",
    "senseResultats": "Cap permís coincideix amb la cerca",
    "grups": {
      "guardies": "Guàrdies",
      "activacions": "Activacions",
      "organitzacio": "Àrees, serveis i documentació",
      "notificacions": "Notificacions",
      "administracio": "Administració",
      "informes": "Informes i auditoria",
      "altres": "Altres"
    }
  },
  "informar": {
    "alta": "Afegeix manualment",
    "nom": "Nom",
    "email": "Correu electrònic",
    "telefon": "Telèfon",
    "canals": "Canals",
    "importa": "Importa des d'Excel",
    "servei": "Servei",
    "cerca": "Cerca per nom o correu",
    "resum": "{{total}} persones · {{manual}} manuals · {{entra}} d'Entra ID · {{excel}} d'Excel",
    "buit": "Aquest servei no té usuaris a informar.",
    "origen": "Origen",
    "origens": {
      "MANUAL": "Manual",
      "ENTRA": "Entra ID",
      "EXCEL": "Importada d'Excel"
    },
    "treu": "Treu {{nom}}",
    "totes": "Totes ({{count}})",
    "filtreOrigen": {
      "EXCEL": "Importades d'Excel ({{count}})",
      "ENTRA": "Entra ID ({{count}})",
      "MANUAL": "Manuals ({{count}})"
    },
    "nota": "Cada servei (IT o de crisi) té la seva llista d'usuaris a informar",
    "senseLlistes": "Cap llista coincideix amb els filtres",
    "persones": "Persones",
    "area": "Àrea",
    "senseCompte": "Sense compte corporatiu",
    "reimporta": "Reimporta Excel",
    "exporta": "Exporta",
    "personesLlista": "Persones de la llista",
    "mostrant": "Mostrant {{count}} de {{total}}",
    "senseCompteBadge": "Sense compte corporatiu"
  },
  "importacio": {
    "titol": "Importació d'usuaris a informar",
    "fitxer": "Fitxer Excel",
    "ajudaFitxer": "Fitxer .xlsx o .xls · la primera fila ha de contenir les capçaleres.",
    "errorLectura": "No s'ha pogut llegir el fitxer. Comprova que sigui un Excel vàlid.",
    "llegides": "{{nom}}: {{files}} files i {{columnes}} columnes",
    "noImportar": "No importar",
    "mapeigIncomplet": "Cal assignar com a mínim les columnes de nom i correu electrònic.",
    "filesLlegides": "{{count}} files llegides",
    "valides": "Vàlides",
    "duplicades": "Duplicades",
    "errors": "Amb errors",
    "validantServidor": "Validant al servidor…",
    "servei": "Servei de destinació",
    "ajudaAssignacio": "S'assignaran {{count}} persones vàlides al servei seleccionat.",
    "resultat": "Importació completada: {{desats}} desats de {{total}} ({{valids}} vàlids, {{duplicats}} duplicats).",
    "importa": "Importa",
    "passos": {
      "fitxer": "{{n}}. Fitxer",
      "mapeig": "{{n}}. Mapeig de columnes",
      "validacio": "{{n}}. Validació",
      "assignacio": "{{n}}. Assignació al servei"
    },
    "camps": {
      "nom": "Nom",
      "email": "Correu electrònic",
      "telefon": "Telèfon",
      "canals": "Canals"
    },
    "errorFila": {
      "obligatori": "Fila {{fila}}: el camp {{camp}} és obligatori.",
      "email": "Fila {{fila}}: el {{camp}} no és vàlid.",
      "duplicat": "Fila {{fila}}: {{camp}} duplicat.",
      "telefon": "Fila {{fila}}: el {{camp}} no és vàlid."
    },
    "formatNoValid": "Només s'admeten fitxers d'Excel (.xlsx o .xls).",
    "primerFitxer": "Tria primer un fitxer Excel.",
    "campPlataforma": "Camp de la plataforma",
    "columnaExcel": "Columna de l'Excel",
    "exemple": "Exemple",
    "nValids": "{{count}} vàlids",
    "ajudaValids": "Es poden importar a la llista del servei",
    "nDuplicats": "{{count}} duplicats",
    "ajudaDuplicats": "Es descarten les files repetides pel correu",
    "nErrors": "{{count}} amb errors",
    "validaServidor": "Valida al servidor",
    "validatServidor": "Validat al servidor",
    "importaN": "Importa {{count}} persones"
  },
  "arees": {
    "novaArea": "Nova àrea",
    "nouDepartament": "Nou departament",
    "codi": "Codi",
    "nom": "Nom",
    "tipus": "Tipus",
    "nouServei": "Nou servei",
    "descripcio": "Descripció",
    "tecnicGuardia": "Tècnic de guàrdia",
    "tecnicGuardiaCrisi": "Opcional en àrees de crisi: es determina pel calendari de l'àrea.",
    "tecnicGuardiaIt": "Es determina pel calendari de guàrdia de l'àrea.",
    "expert": "Tècnic expert",
    "senseExpert": "Sense tècnic expert assignat.",
    "expertTipus": {
      "TITULAR": "Titular",
      "SUBSTITUT": "Substitut"
    },
    "usuarisInformar": "Usuaris a informar",
    "resumInformar": "{{count}} persones ({{origen}})",
    "gestionaInformar": "Gestiona",
    "plantilla": "Plantilla de missatge",
    "sensePlantilla": "Sense plantilla",
    "circuit": "Circuit d'escalat",
    "circuitDefecte": "Circuit per defecte",
    "canalsDefecte": "Canals per defecte",
    "procediment": "Procediment alternatiu",
    "documentacio": "Documentació",
    "totes": "Totes",
    "departaments": "Departaments",
    "arees": "Àrees",
    "serveis": "Serveis",
    "senseArees": "Aquest departament no té àrees.",
    "senseServeis": "Aquesta àrea no té serveis.",
    "ajudaCrisi": "El flux d'obertura és el mateix que per a un servei IT: Servei, Tipus, Dades, Destinataris i Revisió. Només canvien els camps buits (tècnic expert) i la plantilla, que afegeix zona, risc, perills i mesures.",
    "area": "Àrea",
    "departament": "Departament",
    "tipusArea": "Tipus d'àrea",
    "circuitResum": "{{nom}} · {{count}} nivells",
    "tecnicGuardiaArea": "Tècnic de guàrdia de l'àrea",
    "opcionalCrisi": "Opcional en àrees de crisi",
    "titularFins": "Titular · fins {{data}}",
    "opcional": "Opcional",
    "mes": "+{{count}} més",
    "documentacioServei": "Documentació del servei",
    "obreBiblioteca": "Obre a la biblioteca",
    "senseDocuments": "Aquest servei no té documents",
    "configuracio": "Configuració del servei",
    "tots": "Tots",
    "serveisDe": "Serveis de {{area}}",
    "triaServei": "Tria un servei per veure la seva fitxa"
  },
  "circuits": {
    "inici": "Activació",
    "fi": "Fi de l'escalat",
    "nivell": "Nivell {{n}}",
    "desti": {
      "TECNIC_GUARDIA_TITULAR": "Tècnic de guàrdia titular",
      "TECNIC_GUARDIA_SUBSTITUT": "Tècnic de guàrdia substitut",
      "TECNIC_GUARDIA_DEPARTAMENT": "Tècnic de guàrdia del departament",
      "TECNIC_GUARDIA_ALTRES_AREES": "Tècnics de guàrdia d'altres àrees",
      "EXPERT_TITULAR": "Tècnic expert titular",
      "EXPERT_SUBSTITUT": "Tècnic expert substitut",
      "USUARI": "Persona concreta",
      "GRUP": "Grup"
    },
    "immediat": "Immediat",
    "espera": "Espera {{min}} min",
    "nou": "Nou circuit",
    "perDefecte": "Per defecte",
    "tempsTotal": "Temps total: {{min}} min",
    "diagrama": "Diagrama del circuit d'escalat",
    "nom": "Nom",
    "servei": "Servei",
    "general": "General (tots els serveis)",
    "marcaDefecte": "Circuit per defecte",
    "nivells": "Nivells d'escalat",
    "puja": "Puja el nivell {{n}}",
    "baixa": "Baixa el nivell {{n}}",
    "treu": "Treu el nivell {{n}}",
    "amunt": "Amunt",
    "avall": "Avall",
    "destinatari": "Destinatari",
    "destiNivell": "Destinatari del nivell {{n}}",
    "esperaMin": "Espera sense confirmació (min)",
    "esperaNivell": "Espera del nivell {{n}} en minuts",
    "afegeixNivell": "Afegeix nivell",
    "senseCanals": "Cada nivell ha de tenir com a mínim un canal.",
    "llista": "Circuits",
    "resum": "{{count}} nivells",
    "buit": "No hi ha circuits configurats.",
    "persona": "Persona",
    "cercaPersona": "Cerca per nom…",
    "personaNivell": "Persona del nivell {{n}}",
    "titolCircuit": "Circuit d'escalat · {{nom}}",
    "esperaCurt": "Espera",
    "minuts": "{{n}} min",
    "senseUsuari": "Els nivells de tipus «Persona concreta» han de tenir una persona assignada.",
    "descDesti": {
      "TECNIC_GUARDIA_TITULAR": "Titular del calendari de guàrdia de l'àrea",
      "TECNIC_GUARDIA_SUBSTITUT": "Substitut segons calendari",
      "TECNIC_GUARDIA_DEPARTAMENT": "Guàrdia del departament · rotació",
      "TECNIC_GUARDIA_ALTRES_AREES": "Tècnics de guàrdia de la resta d'àrees del departament",
      "EXPERT_TITULAR": "Tècnic expert titular del servei",
      "EXPERT_SUBSTITUT": "Tècnic expert substitut del servei",
      "USUARI": "Persona sense assignar",
      "GRUP": "Grup de destinataris"
    },
    "editaNivell": "Edita el nivell {{n}}"
  },
  "canals": {
    "matriu": "Canals obligatoris per tipus d'avís",
    "ajuda": "Defineix per a cada tipus d'avís els canals que s'utilitzen i el temps de confirmació abans d'escalar.",
    "tipusAvis": "Tipus d'avís",
    "critica": "Pot ser crítica",
    "canalDe": "Canal {{canal}} per a {{tipus}}",
    "tempsConfirmacio": "Temps de confirmació (min)",
    "tempsDe": "Temps de confirmació de {{tipus}} en minuts",
    "desaTipus": "Desa {{tipus}}",
    "desaServei": "Desa els canals de {{servei}}",
    "regles": "Regles generals",
    "reintents": "Reintents",
    "reintentsValor": "Fins a 3 reintents per canal amb espera exponencial.",
    "antiDuplicats": "Anti-duplicats",
    "antiDuplicatsValor": "Clau d'idempotència per destinatari, canal i nivell (RF-058).",
    "idioma": "Idioma",
    "idiomaValor": "Cada destinatari rep el missatge en el seu idioma preferit (ca/es).",
    "excepcions": "Excepcions per servei",
    "min": "min",
    "senseTipus": "No hi ha tipus d'avís configurats",
    "serveiArea": "Servei · àrea",
    "canalsDefecte": "Canals per defecte"
  },
  "plantilles": {
    "nova": "Nova plantilla",
    "idioma": "Idioma de la plantilla",
    "codi": "Codi",
    "tipus": "Tipus",
    "titolMissatge": "Títol",
    "cos": "Cos del missatge (correu)",
    "cosPush": "Text de la notificació push",
    "cosVeu": "Locució de la trucada",
    "variables": "Variables disponibles",
    "previsualitzacio": "Previsualització per canal",
    "canal": "Canal de previsualització",
    "previaServidor": "Previsualitza al servidor",
    "llista": "Plantilles",
    "buit": "No hi ha plantilles.",
    "insereix": "Insereix la variable al text"
  },
  "zones": {
    "nova": "Nova zona",
    "edita": "Edita la zona",
    "editaZona": "Edita {{nom}}",
    "codi": "Codi",
    "nom": "Nom",
    "tipus": "Tipus",
    "adreca": "Adreça",
    "pare": "Zona superior",
    "sensePare": "Cap",
    "cerca": "Cerca zones",
    "buit": "No hi ha zones.",
    "tipusZona": {
      "CENTRE": "Centre",
      "PLANTA": "Planta",
      "BOTIGA": "Botiga",
      "OFICINA": "Oficina",
      "ALTRE": "Altre"
    },
    "zona": "Zona"
  },
  "integracions": {
    "prova": "Comprova ara",
    "provant": "Comprovant…",
    "cua": "Missatges a la cua",
    "latenciaP50": "Latència p50",
    "latenciaP95": "Latència p95",
    "ms": "{{n}} ms",
    "configuracio": "Configuració",
    "enviats": "Enviats",
    "fallits": "Fallits",
    "ultimError": "Últim error",
    "secrets": "Les credencials es desen a Azure Key Vault i no es mostren mai.",
    "actualitzat": "Estat actualitzat: {{data}}",
    "estat": {
      "OK": "Operativa",
      "DEGRADAT": "Degradada",
      "KO": "Error",
      "DESCONEGUT": "Sense dades",
      "NO_CONFIGURAT": "No configurada"
    },
    "ENTRA": {
      "nom": "Microsoft Entra ID",
      "descripcio": "Inici de sessió únic i sincronització d'usuaris, grups i departaments via Microsoft Graph.",
      "config": "Permisos User.Read.All i Group.Read.All amb consentiment d'administrador."
    },
    "ITCAU": {
      "nom": "ITCAU / HaloITSM",
      "descripcio": "Vincle manual amb la referència de la incidència ITCAU, sense sincronització de camps.",
      "config": "Referència manual introduïda a cada activació. Credencials, si n'hi ha, a Azure Key Vault."
    },
    "MAILJET": {
      "nom": "Mailjet (correu electrònic)",
      "descripcio": "Enviament de correus i webhooks d'entrega, obertura i rebot.",
      "config": "Remitent cai@cai.ba-tech.net amb SPF i DKIM."
    },
    "TWILIO": {
      "nom": "Twilio (trucades de veu)",
      "descripcio": "Trucades automàtiques amb locució en català i castellà i confirmació amb el teclat.",
      "config": "Webhooks protegits amb validació de X-Twilio-Signature."
    },
    "PUSH": {
      "nom": "Notificacions push (APNs / FCM)",
      "descripcio": "Enviament directe per FCM i APNs amb alertes crítiques d'iOS i canal d'alarma d'Android.",
      "config": "Entitlement d'alertes crítiques i canal d'alta importància."
    },
    "darreraComprovacio": "Darrera comprovació"
  },
  "versions": {
    "nova": "Publica versió",
    "publica": "Publica",
    "plataforma": "Plataforma",
    "plataformes": {
      "IOS": "iOS",
      "ANDROID": "Android"
    },
    "versio": "Versió",
    "build": "Build",
    "notes": "Notes",
    "notesCa": "Notes (català)",
    "notesEs": "Notes (castellà)",
    "urlBotiga": "URL de la botiga",
    "minimaObligatoria": "Versió mínima obligatòria",
    "minimaDe": "Versió mínima {{plataforma}}",
    "cap": "Cap",
    "historial": "Historial de versions",
    "publicada": "Publicada",
    "missatges": "Missatges administratius",
    "senseMissatges": "No hi ha missatges administratius.",
    "nouMissatge": "Nou missatge",
    "editaMissatge": "Edita el missatge",
    "tipus": "Tipus",
    "tipusMissatge": {
      "INFO": "Informació",
      "ACTUALITZACIO": "Actualització disponible",
      "VERSIO_MINIMA": "Versió mínima",
      "MANTENIMENT": "Manteniment"
    },
    "titolCa": "Títol (català)",
    "titolEs": "Títol (castellà)",
    "cosCa": "Text (català)",
    "cosEs": "Text (castellà)",
    "versioMin": "Des de la versió",
    "versioMax": "Fins a la versió",
    "previa": "Previsualització a l'app",
    "dacord": "D'acord",
    "minimes": "Versions mínimes obligatòries",
    "darreraDe": "{{plataforma}} · darrera publicada",
    "missatge": "Missatge",
    "vigencia": "Vigència",
    "estat": "Estat",
    "indefinit": "Indefinit",
    "senseVersions": "Encara no hi ha cap versió publicada.",
    "previsualitzacio": "Previsualització"
  },
  "configuracio": {
    "regional": "Idioma i fus horari",
    "idioma": "Idioma per defecte",
    "fus": "Fus horari",
    "escalatDefecte": "Temps d'escalat per defecte (min)",
    "retencio": "Retenció de dades",
    "anys": "Anys de retenció",
    "retencioMinima": "La retenció mínima és de 3 anys (RNF-009).",
    "ajudaRetencio": "Passat aquest termini, els registres, missatges i evidències es purguen o s'anonimitzen automàticament.",
    "procediment": "Procediment alternatiu",
    "ajudaProcediment": "Es mostra a l'app quan l'app o les notificacions no funcionen.",
    "telefon": "Telèfon d'emergència",
    "procedimentCa": "Procediment (català)",
    "procedimentEs": "Procediment (castellà)",
    "auditoria": "Auditoria de canvis de configuració",
    "senseCanvis": "No hi ha canvis registrats.",
    "quan": "Data i hora",
    "qui": "Persona",
    "accio": "Acció",
    "clau": "Element",
    "previ": "Valor previ",
    "nou": "Valor nou",
    "resultat": "Resultat",
    "resultatOk": "Correcte",
    "resultatKo": "Error",
    "canvi": "Canvi"
  },
  "documents": {
    "puja": "Puja document",
    "substitueix": "Nova versió de {{titol}}",
    "tanca": "Tanca",
    "pujant": "Pujant…",
    "enviaAnalisi": "Puja i analitza",
    "ajudaAnalisi": "El fitxer s'analitza amb antimalware abans de publicar-se. Mentre dura l'anàlisi el document queda En anàlisi.",
    "fitxer": "Fitxer",
    "politicaResum": "Formats permesos: {{formats}} · Mida màxima {{mida}} MB · Màxim {{max}} documents per servei",
    "formatInvalid": "El format .{{ext}} no està permès.",
    "massaGran": "El fitxer supera la mida màxima de {{mida}} MB.",
    "servei": "Servei",
    "titol": "Títol",
    "categoria": "Categoria",
    "ambit": "Àmbit",
    "ambits": {
      "SERVEI": "Servei",
      "AREA": "Àrea",
      "DEPARTAMENT": "Departament"
    },
    "comentari": "Comentari de la versió",
    "politica": "Política de fitxers",
    "cerca": "Cerca documents",
    "totsServeis": "Tots els serveis",
    "estat": "Estat",
    "totsEstats": "Tots els estats",
    "estats": {
      "PUBLICAT": "Vigent",
      "ESBORRANY": "En anàlisi",
      "BLOQUEJAT": "Bloquejat",
      "RETIRAT": "Retirat"
    },
    "escaneig": {
      "PENDENT": "En anàlisi",
      "NET": "Net",
      "INFECTAT": "Bloquejat per malware",
      "ERROR": "Error d'anàlisi"
    },
    "buit": "No hi ha documents.",
    "versio": "Versió",
    "vN": "v{{n}}",
    "actualitzat": "Última actualització",
    "responsable": "Responsable",
    "descarrega": "Descarrega",
    "descarregaVersio": "Descarrega la versió {{n}}",
    "novaVersio": "Substitueix (nova versió)",
    "retira": "Retira el document",
    "confirmaRetirada": "Retira",
    "motiu": "Motiu",
    "dades": "Dades del document",
    "versioVigent": "Versió vigent",
    "senseVigent": "Sense versió vigent",
    "auditoria": "Auditoria",
    "senseAuditoria": "Sense registres d'auditoria.",
    "versions": "Historial de versions",
    "mida": "Mida",
    "pujatPer": "Pujat per",
    "data": "Data",
    "analisi": "Anàlisi antimalware",
    "codi": "Codi",
    "totsN": "Tots ({{count}})",
    "filtreEstat": {
      "PUBLICAT": "Vigents ({{count}})",
      "ESBORRANY": "En anàlisi ({{count}})",
      "BLOQUEJAT": "Bloquejats ({{count}})",
      "RETIRAT": "Retirats ({{count}})"
    },
    "notaAmbits": "Només es mostren els documents dels àmbits on tens permís de consulta o gestió",
    "serveiArea": "Servei · àrea",
    "format": "Format",
    "notaPeu": "Els documents bloquejats, retirats o no vàlids no es poden obrir.",
    "metadades": "Metadades",
    "conservacio": "Es conserva durant 3 anys",
    "senseVersions": "Encara no hi ha versions",
    "notaCanvi": "Nota de canvi",
    "vigent": "Vigent",
    "substituida": "Substituïda",
    "ambitAcces": "Àmbit d'accés",
    "heretat": "Heretat del servei",
    "descarregable": "Descàrrega permesa",
    "si": "Sí",
    "no": "No",
    "arrossega": "Arrossega el fitxer aquí o selecciona'l",
    "analisiAbans": "Anàlisi de seguretat abans de publicar",
    "checkFormat": "Format admès",
    "checkMida": "Mida dins del límit",
    "midaDe": "{{mida}} de {{max}} MB",
    "checkAntimalware": "Anàlisi antimalware",
    "checkAntimalwareText": "Es fa en pujar el fitxer, abans de publicar-lo",
    "senseFitxer": "Encara no has triat cap fitxer"
  },
  "politica": {
    "titol": "Política de fitxers",
    "formats": "Formats permesos",
    "capFormat": "Cal permetre com a mínim un format.",
    "limits": "Límits",
    "midaMax": "Mida màxima per fitxer (MB)",
    "maxDocuments": "Nombre màxim de documents per servei",
    "seguretat": "Seguretat",
    "antimalware": "Tots els fitxers s'analitzen amb Microsoft Defender for Storage abans de publicar-se.",
    "bloqueig": "Els fitxers infectats, retirats o no vàlids queden bloquejats i no es poden descarregar.",
    "historial": "Es conserva l'historial de versions i l'auditoria de cada document.",
    "formatsLimits": "Formats i límits",
    "rebutjats": "Sempre rebutjats",
    "darrerCanvi": "Darrer canvi: {{data}}",
    "sempreActiu": "Sempre actiu",
    "noDisponibles": "Fitxers no disponibles",
    "consulta": "Consulta",
    "comportament": "Comportament",
    "impedida": "Impedida",
    "conservacio": "Conservació i auditoria",
    "controls": {
      "antimalware": {
        "titol": "Anàlisi antimalware obligatòria",
        "text": "Cap document es publica fins que la supera"
      },
      "formatReal": {
        "titol": "Validació del format real",
        "text": "Comprova la signatura, no només l'extensió"
      },
      "macros": {
        "titol": "Bloqueig de macros",
        "text": "Rebutja documents amb contingut actiu"
      },
      "executables": {
        "titol": "Bloqueig d'executables i scripts",
        "text": "També dins de fitxers comprimits"
      },
      "marcaAigua": {
        "titol": "Marca d'aigua en la consulta",
        "text": "Nom de la persona, data i hora"
      }
    },
    "estats": {
      "ESBORRANY": "En anàlisi",
      "BLOQUEJAT": "Bloquejat",
      "RETIRAT": "Retirat",
      "NO_VALID": "No vàlid"
    },
    "comportaments": {
      "ESBORRANY": "Es manté visible la versió vigent anterior",
      "BLOQUEJAT": "Fitxer en quarantena · avís al responsable i a l'administrador",
      "RETIRAT": "Es mostra el document que el substitueix, si n'hi ha",
      "NO_VALID": "Fitxer malmès o format no admès · cal tornar-lo a pujar"
    }
  },
  "auditoria": {
    "accions": {
      "CREAR": "Alta",
      "MODIFICAR": "Modificació",
      "ELIMINAR": "Baixa",
      "CONSULTAR": "Consulta",
      "LOGIN": "Inici de sessió",
      "LOGOUT": "Tancament de sessió",
      "ASSIGNAR_ROL": "Assignació de rol",
      "TREURE_ROL": "Retirada de rol",
      "SINCRONITZAR": "Sincronització",
      "CONFIRMAR": "Confirmació de recepció",
      "ACCEPTAR": "Acceptació",
      "DESCARREGAR": "Descàrrega",
      "PUJAR": "Pujada",
      "RETIRAR": "Retirada",
      "PUBLICAR": "Publicació",
      "EXPORTAR": "Exportació",
      "PERMIS_DENEGAT": "Accés denegat"
    },
    "entitats": {
      "usuari": "usuari",
      "rol": "rol",
      "activacio": "activació",
      "configuracio": "configuració",
      "document": "document",
      "torn": "torn",
      "calendari": "calendari",
      "servei": "servei",
      "area": "àrea",
      "plantilla": "plantilla",
      "circuit": "circuit d'escalat",
      "sessio": "sessió",
      "dispositiu": "dispositiu",
      "appversio": "versió de l'app",
      "informe_programat": "informe programat",
      "permis": "permís",
      "zona": "zona",
      "tipusavis": "tipus d'avís",
      "sollicitud": "sol·licitud de canvi",
      "expert": "expert",
      "missatge": "missatge",
      "departament": "departament",
      "grup": "grup",
      "circuit_escalat": "circuit d'escalat",
      "app_versio": "versió de l'app",
      "missatge_admin": "missatge d'administració",
      "tipus_avis": "tipus d'avís",
      "sollicitud_canvi_torn": "sol·licitud de canvi de torn",
      "document_versio": "versió de document",
      "politica_fitxers": "política de fitxers",
      "rotacio": "rotació"
    },
    "accionsCompletes": {
      "usuari_edicio": "Modificació del perfil · usuari",
      "usuari_alta": "Alta de persona",
      "usuari_preferencies": "Canvi de preferències",
      "usuari_telefon": "Canvi o confirmació del mòbil",
      "usuari_rol_assignar": "Assignació de rol",
      "usuari_rol_revocar": "Retirada de rol",
      "usuari_sync_entra": "Sincronització amb Entra ID",
      "usuari_sync_entra_individual": "Sincronització amb Entra ID · usuari",
      "grup_membre_alta": "Alta de membre · grup",
      "grup_membre_baixa": "Baixa de membre · grup",
      "servei_experts_desar": "Canvi d'experts · servei",
      "servei_circuit_desar": "Canvi de circuit d'escalat · servei",
      "servei_usuari_informar_alta": "Alta de persona a informar · servei",
      "servei_usuari_informar_edicio": "Modificació de persona a informar · servei",
      "servei_usuari_informar_baixa": "Baixa de persona a informar · servei",
      "servei_usuaris_informar_import": "Importació de persones a informar · servei",
      "rol_permisos_desar": "Canvi de permisos · rol",
      "document_politica_desar": "Canvi de política de fitxers",
      "document_politica_eliminar": "Eliminació de política de fitxers"
    },
    "canvis": {
      "senseCanvis": "Sense canvis de dades",
      "dades": "Dades registrades:",
      "eliminat": "Dades abans de l'eliminació:",
      "mes_one": "… i {{count}} camp més",
      "mes_other": "… i {{count}} camps més",
      "si": "Sí",
      "no": "No",
      "per": "per {{qui}}"
    },
    "camps": {
      "nom": "Nom",
      "cognoms": "Cognoms",
      "email": "Correu",
      "telefon": "Mòbil",
      "telefonConfirmat": "Mòbil confirmat",
      "departamentId": "Departament",
      "areaId": "Àrea",
      "serveiId": "Servei",
      "carrec": "Càrrec",
      "idioma": "Idioma",
      "actiu": "Actiu",
      "canalsPreferits": "Canals preferits",
      "canalsDefecte": "Canals per defecte",
      "biometria": "Biometria",
      "campsLocals": "Camps bloquejats a la sincronització",
      "rols": "Rols",
      "codi": "Codi",
      "descripcio": "Descripció",
      "tipus": "Tipus",
      "adreca": "Adreça",
      "pareId": "Zona pare",
      "plantillaId": "Plantilla",
      "circuitEscalatId": "Circuit d'escalat",
      "procedimentAlternatiu": "Procediment alternatiu",
      "entraGroupId": "Grup d'Entra ID",
      "entraOid": "Identificador d'Entra ID",
      "upn": "Usuari (UPN)",
      "membres": "Membres",
      "estat": "Estat",
      "titol": "Títol",
      "versio": "Versió",
      "usuariId": "Persona",
      "calendariId": "Calendari",
      "inici": "Inici",
      "fi": "Fi",
      "motiu": "Motiu",
      "comentari": "Comentari"
    },
    "verbs": {
      "alta": "Alta",
      "baixa": "Baixa",
      "modificar": "Modificació",
      "eliminar": "Eliminació",
      "edicio": "Edició",
      "tancar": "Tancament",
      "escalar": "Escalat",
      "estat": "Canvi d'estat",
      "expert": "Expert activat",
      "itcau": "Vinculació ITCAU",
      "destinataris": "Destinataris",
      "retirar": "Retirada",
      "substituir": "Substitució",
      "escaneig": "Anàlisi antimalware",
      "nova": "Nova",
      "csv": "Exportació CSV",
      "consulta": "Consulta",
      "descarrega": "Descàrrega",
      "sincronitzar": "Sincronització",
      "confirmar": "Confirmació",
      "acceptar": "Acceptació"
    }
  },
  "ajustos": {
    "titol": "Configuració",
    "subtitol": "Tot el que es configura un cop i es toca poc, fora del menú del dia a dia.",
    "cerca": "Cerca un ajust: «plantilla», «escalat», «importar»…",
    "cercaEtiqueta": "Cerca un ajust",
    "senseResultats": "Cap ajust coincideix amb la cerca.",
    "grups": {
      "persones": "Persones",
      "organitzacio": "Organització",
      "comunicacio": "Comunicació",
      "documentacio": "Documentació",
      "sistema": "Sistema"
    },
    "items": {
      "usuaris": {
        "titol": "Usuaris",
        "text": "Altes, àrees i permisos de cada persona"
      },
      "rols": {
        "titol": "Rols",
        "text": "Què pot fer cada perfil"
      },
      "usuarisInformar": {
        "titol": "Usuaris a informar",
        "text": "Llistes per servei · importació des d’Excel"
      },
      "arees": {
        "titol": "Estructura",
        "text": "Departaments, àrees, serveis i guàrdies"
      },
      "zones": {
        "titol": "Zones",
        "text": "Centres, plantes i ubicacions"
      },
      "circuits": {
        "titol": "Circuits d’escalat",
        "text": "A qui s’avisa i quan s’escala"
      },
      "canals": {
        "titol": "Canals d’avís",
        "text": "App, SMS, correu i trucada; reintents"
      },
      "plantilles": {
        "titol": "Plantilles de missatge",
        "text": "Camps i textos per servei"
      },
      "documentacio": {
        "titol": "Documents de servei",
        "text": "Procediments que s’adjunten a les activacions"
      },
      "politicaFitxers": {
        "titol": "Política de fitxers",
        "text": "Tipus i mides permesos"
      },
      "integracions": {
        "titol": "Integracions",
        "text": "ITCAU, Entra ID, SMS"
      },
      "monitoratge": {
        "titol": "Monitoratge",
        "text": "Estat dels enviaments i dels serveis"
      },
      "versions": {
        "titol": "Versions de l’app",
        "text": "Versió mínima i avisos d’actualització"
      },
      "configuracio": {
        "titol": "Configuració general",
        "text": "Temps, idiomes i valors per defecte"
      }
    }
  }
}
